import { render, staticRenderFns } from "./StateBrowserUsermenu.vue?vue&type=template&id=21924868&"
import script from "./StateBrowserUsermenu.vue?vue&type=script&lang=js&"
export * from "./StateBrowserUsermenu.vue?vue&type=script&lang=js&"
import style0 from "./StateBrowserUsermenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports